<template>
  <div
    class="head"
    @click="closeSearchResult"
    v-if="!isTripartite"
  >
    <Notice
      ref="notice"
      v-if="info"
    ></Notice>
    <div class>
      <Header class="page-header page-header1">
        <router-link
          to="/"
          class="logo"
          v-if="!isPrivate"
        ></router-link>
        <router-link
          to="/"
          class="logo"
          style="background:none;line-height: 45px;width: 144px;"
          v-else
        >AI-Transcription</router-link>
        <!-- <a v-if="!meta.portal" class="logo-subtitle">| 标注平台</a> -->
        <div class="nav">
          <div
            class="item"
            v-if="!meta.portal"
          >
            <router-link
              :class="curPath == navPath.default ? 'active':'' "
              :to="navPath.default"
            >{{$t('topNav1')}}</router-link>
          </div>
          <div
            class="item"
            v-if="!meta.portal"
          >
            <router-link
              :class="curPath == navPath.task ? 'active':'' "
              :to="navPath.task"
            >{{$t('topNav2')}}</router-link>
            <!-- <a :href="abkLink() + '/open/index/task'" ref="guideNavTaskBox">{{$t('topNav2')}}</a> -->
          </div>
          <div
            class="item"
            v-if="!meta.portal"
          >
            <router-link
              :class="curPath == navPath.guild ? 'active':'' "
              :to="navPath.guild"
            >{{$t('topNav3')}}</router-link>
          </div>

          <!-- <div class="item" ref="guideNavMedalBox" v-if="!meta.portal">
            <a :href="abkLink() + '/open/index/medal'" ref="guideNavTeamBox">{{$t('topNav4')}}</a>
          </div>-->

          <!-- <div class="item">
            <a :href="abkLink() + '/open/index/medal'" >{{$t('topNav4')}}</a>
          </div>-->
          <!-- <div class="item">
            <a :href="abkLink() + '/user/member/index'" ref="guideNavMyBox">{{$t('topNav5')}}</a>
          </div>-->
          <!-- <div class="item">
            <a :href="$t('abkLink')+'/manager/index/home'">{{$t('topNav6')}}</a>
          </div>-->
          <!-- <div class="item">
            <router-link :class="curPath == navPath.union ? 'active':'' " :to='navPath.union'>{{$t('Layout-TopNav0') || '公会大厅'}}</router-link>
          </div>-->
          <!-- <div class="item">
            <router-link :class="curPath == navPath.work ? 'active':'' " :to='navPath.work'>{{$t('Layout-TopNav1') || '工作台'}}</router-link>
          </div>-->
          <!-- <div class="item" v-if="meta.portal">
            <router-link :class="curPath.indexOf(navPath.portal) > -1  ? 'active':'' " to='/'>{{$t('topNav1')}}</router-link>
          </div>-->
          <div
            class="item"
            v-if="meta.portal"
          >
            <router-link
              :class="curPath.indexOf(navPath.default) > -1  ? 'active':'' "
              :to="navPath.default"
            >{{$t('topNav30')}}</router-link>
          </div>
          <div
            class="item"
            v-if="meta.portal"
          >
            <router-link
              :class="curPath.indexOf(navPath.company) > -1  ? 'active':'' "
              :to="navPath.company"
            >{{$t('protalTitle2')}}</router-link>
          </div>
          <!-- <div class="item" v-if="meta.portal">
            <router-link
              :class="curPath.indexOf(navPath.help) > -1  ? 'active':''"
              :to="{path:navPath.help,query:{type:'portal'}}"
            >{{$t('topNav7')}}</router-link>
          </div> -->
          <div
            class="item"
            v-if="!meta.portal"
          >
            <router-link
              :class="curPath.indexOf(navPath.help) > -1  ? 'active':'' "
              :to="navPath.help"
            >{{$t('topNav7')}}</router-link>
          </div>

          <!-- <div class="item" v-if="meta.portal">
            <router-link
              :class="curPath.indexOf(navPath.app) > -1  ? 'active':'' "
              :to="{path:navPath.app,query:{type:'portal'}}"
            >{{$t('topNav8')}}</router-link>
          </div> -->
          <!--          <div-->
          <!--            class="item"-->
          <!--            v-if="!meta.portal && !isPrivate"-->
          <!--          >-->
          <!--            <router-link-->
          <!--              :class="curPath.indexOf(navPath.app) > -1  ? 'active':'' "-->
          <!--              :to="navPath.app"-->
          <!--            >{{$t('topNav8')}}</router-link>-->
          <!--          </div>-->

          <!-- <div class="item mobile" >
            <span class="more" >{{$t('topNav14')}} <u></u></span>
            <div class="box">
              <div class="type">
                <router-link :to='navPath.app'>{{$t('topNav8')}}</router-link>
              </div>
              <div class="type">
                <span>{{$t('home26')}} <u></u></span>
                <div class="img">
                  <i class="topLeft"></i>
                  <i class="topRight"></i>
                  <i class="bottomLeft"></i>
                  <i class="bottomRight"></i>
                  <img :src="appAbk" alt="">
                  <p>{{$t('home27')}}</p>
                </div>
              </div>
              <div class="type">
                <span>{{$t('home28')}} <u></u></span>
                <div class="img">
                  <i class="topLeft"></i>
                  <i class="topRight"></i>
                  <i class="bottomLeft"></i>
                  <i class="bottomRight"></i>
                  <img :src="appIos" alt="">
                  <p>{{$t('home29')}}</p>
                </div>
              </div>
              <div class="type">
                <span>{{$t('home30')}} <u></u></span>
                <div class="img">
                  <i class="topLeft"></i>
                  <i class="topRight"></i>
                  <i class="bottomLeft"></i>
                  <i class="bottomRight"></i>
                  <img :src="wechatApp" alt="">
                  <p>{{$t('home31')}}</p>
                </div>
              </div>

            </div>
          </div>-->

          <div
            class="search"
            v-if="!meta.portal && false"
            @click.stop="openSearchBox"
          >
            <div
              class="input radius"
              :class="{'open':isOpen}"
              @click="getSearch('open')"
            >
              <input
                type="text"
                v-model="keyWord"
                @keyup.enter="getSearch"
                @focus="getSearch"
                :placeholder="$t('home34')"
              />
              <i class="searchIcon"></i>
            </div>
            <div
              class="searchResult"
              v-show="showSearchResult"
            >
              <!-- <p v-if="searchResultData && searchResultData.length > 0">{{$t('home32')}}</p> -->
              <div class="box">
                <Tabs value="name0">
                  <TabPane
                    :label="$t(key)"
                    :key="index"
                    :name="'name'+ index "
                    class="tab"
                    v-for="(task, key, index) in formatResultData"
                  >
                    <p
                      @click="getSearchDetail(item)"
                      :key="index"
                      v-for="(item,index) in task"
                    >
                      {{item.entryType | searchType($cookies.get('lang')) }}
                      <span v-html="item.entry"></span>
                    </p>
                    <p v-if="task.length === 0">{{$t('home33')}}</p>
                  </TabPane>
                </Tabs>
                <!-- <p @click="getSearchDetail(item)" :key="index" v-for="(item,index) in searchResultData">
                  {{item.entryType | searchType($cookies.get('lang')) }}
                  <span v-html="item.entry"></span>
                </p>-->
              </div>
            </div>
          </div>
        </div>

        <!--<div class="item mobile manage manage1" v-if=" info.name">
          <a class="more" @click="toLink('/manager/index/home')"> {{$t('Layout-TopNav2') || '管理中心'}} <u></u></a>
           <div class="box">
            <div class="type">
              <span @click="toLink('/user/member/task/mytask')">{{$t('topNav10')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/user/member/mymedal')">{{$t('topNav11')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/user/member/myteam')">{{$t('topNav12')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/user/member/mypoints')">{{$t('topNav13')}}</span>
            </div>
          </div>
        </div>-->

        <div
          class="item mobile manage manage1"
          v-if="info"
        >
          <!-- <router-link to=abkLink()+'/manager/index/home' class="top-nav">{{$t('topNav31')}}</router-link> -->
          <a
            class="more"
            href="/manager/index/home"
            v-if="$store.state.app.userPermission.indexOf(2) > -1 && !isPrivate"
          >{{$t('topNav31')}}</a>
          <a
            class="more"
            @click="toManagerv4"
            v-if="$store.state.app.userPermission.indexOf(2) > -1 && !isPrivate"
          >{{$t('topNav33')}}</a>
          <router-link
            to="/guild"
            class="top-nav"
            v-if="$store.state.app.userPermission.indexOf(3) > -1"
          >{{$t('topNav15')}}</router-link>
          <router-link
            to="/WorkBench/WorkBench"
            class="top-nav"
          >{{$t('topNav9')}}</router-link>

          <!-- <div class="box">
             <div class="type">
              <span @click="toLink('/manager/index/task')">{{$t('topNav16')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/manager/index/team')">{{$t('topNav17')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/manager/index/medal/manage')">{{$t('topNav18')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/manager/index/integral/manage')">{{$t('topNav19')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/manager/index/statistics/taskStatistics')">{{$t('topNav20')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/manager/index/talent')">{{$t('topNav21')}}</span>
            </div>
            <div class="type">
              <span @click="toLink('/manager/index/message')">{{$t('topNav22')}}</span>
            </div>
          </div>-->
        </div>
        <!-- <div class="item mobile manage manage1" v-else-if="clientWeight<1334 && info">
          <Dropdown>
            <a href="javascript:void(0)">
              {{$t('Layout-TopNav3') || '工具盒'}}
              <Icon type="ios-arrow-down"></Icon>
            </a>
            <DropdownMenu slot="list">
              <DropdownItem>
                <a href="/manager/index/home">{{$t('topNav31')}}</a>
              </DropdownItem>
              <DropdownItem>
                <router-link to="/guild">{{$t('topNav15')}}</router-link>
              </DropdownItem>
              <DropdownItem>
                <router-link to="/WorkBench/WorkBench">{{$t('topNav9')}}</router-link>
              </DropdownItem>
            </DropdownMenu>
          </Dropdown>
        </div> -->
        <!-- <div class="search" v-if="!meta.portal">
          <div class="input radius">
            <input type="text" v-model="keyWord" @input="getSearch" @focus="getSearch" @blur="closeSearchResult"
                   :placeholder="$t('home34')">
            <i class="searchIcon" @click="getSearch"></i>
          </div>
          <div class="searchResult" v-show="showSearchResult">
            <p v-if="searchResultData && searchResultData.length > 0">{{$t('home32')}}</p>
            <div class="box" v-if=" searchResultData && searchResultData.length > 0">
              <p @click="getSearchDetail(item)" :key="index" v-for="(item,index) in searchResultData">
                {{item.entryType}}
                <span v-html="item.entry"></span>
              </p>
            </div>
            <div class="box" v-else>
              <p>{{$t('home33')}}</p>
            </div>
          </div>
        </div>-->

        <div class="login">
          <div v-if="!info">
            <router-link to="/login">{{$t('login')}} &nbsp;I</router-link>
            <router-link to="/register">&nbsp;{{$t('register')}}</router-link>
          </div>
          <div
            v-else
            class="item mobile manage manage3"
            :title="info.account"
          >
            <router-link
              to="/WorkBench/workBench"
              class="more"
            >
              {{info.account | cutString(11)}}
              <u></u>
            </router-link>
            <div class="box">
              <!-- <div class="type">
                <router-link to='/WorkBench/WorkBench'>{{$t('topNav9')}}</router-link>
              </div>-->
              <!-- <div class="type">
                <router-link to="/WorkBench/AccountSetting/Home">{{$t('topNav27')}}</router-link>
              </div>-->

              <!--<div class="type">
                <span @click="toLink('/user/home/index')">{{$t('topNav26')}}</span>
              </div>
               <div class="type">
                <span @click="toLink('/user/home/validate/name')">{{$t('topNav27')}}</span>
              </div>
              <div class="type">
                <span @click="toLink('/user/home/changepsw')">{{$t('topNav28')}}</span>
              </div>-->
              <div class="type">
                <span @click="loginout">{{$t('topNav29')}}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 门户网退出登录 -->
        <!-- <div class="portalLogin" v-if="meta.portal">
          <div class="btn" v-if="!info.name">
            <a :href="abkLink() +'/open/login'">
              <span class='loginP'>{{$t('login')}}</span>
            </a>
            <a :href="abkLink() +'/open/register/mail'">
              <span class="register">{{$t('register1')}}</span>
            </a>
          </div>
          <div v-else :title="info.name">
            <Dropdown class="name">
              <a href="javascript:void(0)">
                {{info.name }}
                <Icon type="ios-arrow-down"></Icon>
              </a>
              <DropdownMenu slot="list">
                <DropdownItem @click.native="loginout">{{$t('topNav29')}}</DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
        </div>-->

        <div
          class="notice"
          @click="getMessage"
          v-if="info"
        >
          <span v-if="info.count <= 99 && info.count > 0">{{info.count}}</span>
          <span v-if="info.count > 99">99+</span>
        </div>

        <div class="lang">
          <a
            class="langEn"
            v-if="localLang == 'en-US'"
            @click="changeLang('zh-CN')"
          >
            <span class="box">
              <span class="text">EN</span>
            </span>
          </a>
          <a
            class="langCn"
            v-else
            @click="changeLang('en-US')"
          >
            <span class="box">
              <span class="text">CN</span>
            </span>
          </a>
        </div>

        <!--这是底部的企业合作图标-->
        <!-- <div v-if="!meta.portal" class="partner">
          <router-link to='/'>{{$t('protalTitle2')}}</router-link>
        </div>-->
      </Header>
    </div>
    <!-- <AbkGuide v-if="isDefault" ref="guideNavTask" id="guideNavTask" :guideStep="1" :htmlContent="html1" :left="-40" :top="-20" :guideText="$t('guide_task_1')" :guideType="$t('guide_task_2')" link="/open/index/task"></AbkGuide>
    <AbkGuide v-if="isDefault" ref="guideNavTeam" id="guideNavTeam" :guideStep="1" :htmlContent="html2" :left="-40" :top="-20" :guideText="$t('guide_team_1')" :guideType="$t('guide_team_2')" link="/open/index/team"></AbkGuide>
    <AbkGuide v-if="isDefault" ref="guideNavMedal" id="guideNavMedal" :guideStep="1" :htmlContent="html3" :left="-40" :top="-20" :guideText="$t('guide_medal_1')" :guideType="$t('guide_medal_2')" link="/open/index/medal"></AbkGuide>
    <AbkGuide v-if="isDefault" ref="guideNavMy" id="guideNavMy" :guideStep="1" :htmlContent="html4" :left="-40" :top="-20" :guideText="$t('guide_home_1')" :guideType="$t('guide_home_2')" link="/user/home/index"></AbkGuide>-->
  </div>
  <div
    class="head three-platform-head"
    v-else
  >
    <div class>
      <ThirdChangePassword
        :modalOneShow="modalOneShow"
        @cancelHandler="cancelHandler"
        @clearToken="clearToken"
        v-if="info"
      ></ThirdChangePassword>
      <Header class="page-header page-header2">
        <a class="mark-platform">{{$t('Layout-TopNav4') || '标注平台'}}</a>
        <div class="item mobile manage manage1">
          <router-link
            v-if="$store.state.app.userPermission.indexOf(3) > -1"
            to="/guild"
            class="top-nav"
          >{{$t('topNav15')}}</router-link>
          <router-link
            to="/MySociety/SocietyDetail"
            v-if="info"
            class="top-nav"
          >{{$t('topNav9')}}</router-link>
          <Dropdown class="more-menu" v-if="secMenuList.length > 0" @on-click="handleMenuClick">
            <Icon style="cursor: pointer;" type="md-more" />
            <template #list>
                <DropdownMenu>
                    <DropdownItem v-for="item in secMenuList" :key="item.id" :name="item.id">{{item.title}}</DropdownItem>
                </DropdownMenu>
            </template>
          </Dropdown>
        </div>

        <div class="login">

          <div v-if="!info">
            <router-link :to="{name:'Login'}">{{$t('login')}}</router-link>
          </div>
          <div
            v-else
            class="item mobile manage manage3"
            :title="info.account"
          >
            <a class="more">{{info.account | cutString(11)}}</a>
            <!-- <router-link :to='navPath.help' class="more"> {{info.name | cutString(11)}} <u></u></router-link> -->
            <div class="box">
              <div class="type" v-if="info.thirdAccount">
                <div v-if="info.comment" class="comment" :title="info.comment">{{info.comment}}</div>
                <span v-else @click="setNotes">{{$t('topNav32')}}</span>
              </div>
              <div class="type">
                <span @click="changePassWord">{{$t('topNav28')}}</span>
              </div>
              <div class="type">
                <span @click="loginRecord">{{$t('WorkBench-Approve-LoginRecord6')}}</span>
              </div>
              <div class="type">
                <span @click="loginoutLabel">{{$t('topNav29')}}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="notice" @click="getMessage" v-if="info">
          <span v-if="info.count <= 99 && info.count > 0">{{info.count}}</span>
          <span v-if="info.count > 99">99+</span>
        </div>
        <div class="lang">
          <a
            class="langEn"
            v-if="localLang === 'en-US'"
            @click="changeLang('zh-CN')"
          >
            <span class="box">
              <span class="text">EN</span>
            </span>
          </a>
          <a
            class="langCn"
            v-else
            @click="changeLang('en-US')"
          >
            <span class="box">
              <span class="text">CN</span>
            </span>
          </a>
        </div>
      </Header>
    </div>
    <Modal
      width="500px"
      v-model="setNotesShow"
      :title="$t('topNav32')||'设置备注'"
      @on-ok="setNotesOK"
      @on-cancel="setNotesShow = false"
    >
      <span style="margin-left:30px;">{{$t('topNav34')||'为方便公会长管理人员，请将您的备注设置为您的姓名。'}}</span>
      <p style="margin-left:30px;color:red;margin-bottom: 20px;">{{$t('topNav35')||'每人仅1次设置机会，请确保信息填写准确！'}}</p>
      <Form :model="setNotesData" :label-width="100">
        <FormItem :label="$t('topNav40')||'备注：'">
          <Input v-model="setNotesData.comment"  maxlength="20" show-word-limit :placeholder="$t('topNav36')||'请输入备注'"></Input>
           <p style="color: red;" >{{$t('guild-UsersManage-User777')}}</p>
        </FormItem>
        <FormItem :label="$t('topNav79')||'请再输一次：'">
          <Input v-model="setNotesData.commentAgain"  maxlength="20" show-word-limit :placeholder="$t('topNav36')||'请输入备注'"></Input>
        </FormItem>
      </Form>   
    </Modal>
  </div>
</template>

<script>
import { setLocalStorage } from 'http/util/index'
import { RSAencrypt, routePathData, abkLink, jumpDomain } from 'assets/scripts/common'
import * as society from 'http/api/society.js'
import components from 'http/render/components'
import { logout, tripartiteLogout, getAuthInfo, setNotes} from 'http/api/login'
import { getSearch, getTopInfo } from 'http/api/default'

import { authorization, acquire, queryRoleByOpenId } from 'http/api/user'
import Notice from './Notice'
import ThirdChangePassword from './ThirdChangePassword';
export default {
  components: {
    Notice,
    ThirdChangePassword
  },
  data () {
    return {
      options: {
        title: window.i18n.t('guild-UsersManage-User38'),
        okText: window.i18n.t('Layout-TopNav6'),
        cancelText: window.i18n.t('Common-ApplyTask14'),
        loading: true,
        data: [
          {
            title: window.i18n.t('Layout-TopNav8'),
            inputValue: '',
            placeholder: window.i18n.t('guild-UsersManage-User109'),
            role: '.+', // 正则
            style: 'line-height: 30px',
            message: window.i18n.t('guild-UsersManage-User109'),
            key: '' // 自己的key
          },
          {
            title: window.i18n.t('Layout-TopNav11'),
            inputValue: '',
            placeholder: window.i18n.t('Login-Register40'),
            role: '^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{8,20}$', // 正则
            message: window.i18n.t('Login-Forgot222'),
            style: 'line-height: 30px',
            key: '',
            check: true,
            tipClass: 'tipsClass',
            tips: [
              window.i18n.t('tips-password-rule1'),
              '1.' +  window.i18n.t('tips-password-rule2'),
              '2.' +  window.i18n.t('tips-password-rule3'),
              'a)' +  window.i18n.t('tips-password-rule4'),
              'b)' +  window.i18n.t('tips-password-rule5'),
              'c)' +  window.i18n.t('tips-password-rule6'),
              'd)' +  window.i18n.t('tips-password-rule7'),
              '3.' +  window.i18n.t('tips-password-rule8'),
              window.i18n.t('guild-UsersManage-User203'),
              window.i18n.t('Login-Forgot222')
            ]
          },
          {
            title: window.i18n.t('Layout-TopNav14'),
            inputValue: '',
            placeholder: window.i18n.t('Layout-TopNav14'),
            message: window.i18n.t('Layout-TopNav14'),
            role: '^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$).{6,20}$',
            style: 'line-height: 30px',
            key: ''
          }
        ],
        onOk: this.changePassWordOk
      },
      setNotesShow: false,
      setNotesData: {},
      password: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      routePathData: routePathData,
      menuActiveName: '',
      changePasswordVisual: false,
      modalOneShow: false,
      clientWeight: '',
      // password: {
      //   changePassword: ''
      // },
      keyWord: '',
      navPath: {
        default: '/open/default',
        guild: '/guildList',
        company: '/portal/company',
        portal: '/portal/default',
        task: '/task/taskList',
        union: '/union/union',
        work: '/work/work',
        help: '/open/help',
        login: '/login',
        app: '/open/app',
        register: '/register'
      },
      curPath: '',
      isLogin: null,
      localLang: '',
      imgSrc: require('../../assets/images/default/appewm.png'),
      wechatApp: require('../../assets/images/default/wechatApp.jpg'),
      appAbk: require('../../assets/images/default/app_apk.png'),
      appIos: require('../../assets/images/default/app_ios.png'),
      showSearchResult: false,
      searchResultData: [],
      formatResultData: {
        task: [],
        medal: [],
        guild: []
      },
      searchPenging: false,
      isOpen: false,
      isDefault: false, // 是否是首页
      html1:
        "<span style='display:block;color:#4DDB90;font-size: 18px;font-weight:900;line-height:125px;text-align:center;'>" +
        this.$t('topNav2') +
        ' </span>',
      html2:
        "<span style='display:block;color:#4DDB90;font-size: 18px;font-weight:900;line-height:125px;text-align:center;'>" +
        this.$t('topNav3') +
        ' </span>',
      // html3: "<span style='display:block;color:#4DDB90;font-size: 18px;font-weight:900;line-height:125px;text-align:center;'>" + this.$t('topNav4') + ' </span>',
      html4:
        "<span style='display:block;color:#4DDB90;font-size: 18px;font-weight:900;line-height:125px;text-align:center;'>" +
        this.$t('topNav5') +
        ' </span>',
      secMenuList:[]
    }
  },
  props: ['meta', 'isTripartite', 'isPrivate'],
  watch: {
    $route (val) {
      var that = this
      this.curPath = val.path
      this.$nextTick(function () {
        if (this.$route.query.type === 'portal') {
          that.$set(that.meta, 'portal', true)
        }
        if (
          !this.$route.query.type &&
          (this.$route.path === '/open/help/help' ||
            this.$route.path === '/open/app')
        ) {
          that.$set(that.meta, 'portal', false)
        }
      })

      this.isDefault = this.$route.path === '/open/default'

      this.init()
    },
    // 监控屏幕宽度
    clientWeight () {
      this.clientWeight = document.body.clientWidth
      window.onresize = () => {
        return (() => {
          this.clientWeight = document.body.clientWidth
        })()
      }
    }
  },
  computed: {
    info () {
      return this.$store.state.app.userInfo
    }
  },
  mounted: function () {
    // 第三方平台从登陆里取
    if (this.isTripartite) {
      this.getUserInfo()
    } else {
      // 不是第三方平台的话  调用topinfo
      this.init()
    }
    this.isDefault = this.$route.path === '/open/default'
    this.clientWeight = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.clientWeight = document.body.clientWidth
      })()
    }
    // this.modalOneShow = window.localStorage.getItem('initialPassword') =='true'?true:false;
  },
  methods: {
    toManagerv4: function () {
      window.open('/managerv4/', '_blank');
    },
    //关闭弹窗
    cancelHandler () {
      this.modalOneShow = false;
    },
    // 获取用户信息
    getTopInfo: function () {
      // 当前有用户信息后加个时间限制，避免每次点击页面都请求
      let account = this.$store.state.app.userInfo && this.$store.state.app.userInfo.account;
      if (account && sessionStorage.topInfoFlag) {
        let now = new Date().getTime();
        let last = +sessionStorage.topInfoFlag;
        if (now - last < 600000) {
          return;
        }
      }
      if (!sessionStorage.topInfoFlag) {
        sessionStorage.topInfoFlag = new Date().getTime()
      }

      let info = {};
      getTopInfo().then((result) => {
        info = result.data;
        if (JSON.stringify(info) === '{}') {
          info = null
        }
        if (!result.data.headpic === window.i18n.t('Layout-TopNav17')) {
          info.headpic = result.data.headpic;
        }
        // 同步用户信息到vuex
        this.$store.commit('setUserInfo', info);

        // 绑定埋点用户信息
        if (!localStorage.buriedPointFlag) {
          try {
            setAnalysisWebUser(info.account);
          } catch (e) {
            console.log(e)
          }
        }
      });
    },
    init () {
      // debugger
      // 路由变化时有access_token 的话则拉取用户信息  没有的话 去sso登录
      var accessToken = this.$cookies.get('access_token') || this.$cookies.get('token')
      // var backupsTonen = this.$cookies.get('backups_tonen')
      if (accessToken) {
        this.getTopInfo();
      }
      // accessToken 存在 &&  和 备份token相同 或者没有备份
      // if (accessToken && (backupsTonen === accessToken || !backupsTonen)) {
      //   this.getAuthInfo()
      // } else {
      //   // 本地信息不对清空 用户信息
      //   this.$store.commit('setUserInfo', '')
      //   // sso 放在路由加载前
      //   // this.getSso()
      //   this.getAuthInfo()
      // }
    },
    getUserInfo () {
      const userInfo = this.$store.state.app.userInfo
      if (userInfo && userInfo.thirdAccount && !userInfo.comment) {
        this.setNotesShow = true;
      }
    },
    // 设置备注
    setNotes () {
      this.setNotesShow = true;
    },
    setNotesOK () {
      if (!this.setNotesData.comment) {
        this.$Message.warning(window.i18n.t('remark-maxCount1')||'请输入备注，最多可输入十个字');
        return
      }
      if (this.setNotesData.comment !== this.setNotesData.commentAgain) {
        this.$Message.warning(window.i18n.t('remark-checked1')||'两次输入备注不同，请检查后提交!');
        return
      }
      let data = {
        account: this.info.account,
        comment: this.setNotesData.comment
      }
      setNotes(data).then(res => {
        this.$Message.info(window.i18n.t('remark-finish3')||'设置备注成功');
        this.setNotesShow = false;
        this.info.comment = res.data.comment;
        // 同步用户信息到vuex
        this.$store.commit('setUserInfo', this.info)
      })
        .catch(err => {
          console.log(err);
        })
    },
    changePassWord () {
      components.ModelBox(this, this.options) //
    },
    changePassWordOk () {
      this.password.oldPassword = this.options.data[0].inputValue
      this.password.newPassword = this.options.data[1].inputValue
      this.password.confirmPassword = this.options.data[2].inputValue
      // if(this.password.newPassword != this.password.confirmPassword) {
      //   this.$Message.info(window.i18n.t('guild-UsersManage-User203'))
      //   this.$nextTick(()=>{
      //     this.options.loading = false
      //   })
      //   return false
      // }
      // if (!this.ruleValidate(this.password.newPassword) || !this.modeValidate(this.password.newPassword)) {
      //   this.$Message.info(window.i18n.t('Login-Forgot222'))
      //   this.$nextTick(()=>{
      //     this.options.loading = false
      //   })
      //   return false
      // }
      const password = RSAencrypt(this.password, true) // 使用后变成字符串
      society
        .changePassword(JSON.stringify(password))
        .then(res => {
          if (res.data === window.i18n.t('Layout-TopNav18')) {
          }
          this.$Message.success(window.i18n.t('Layout-TopNav19'))
          // console.log(res)
          this.options.loading = false
          this.$Modal.remove()
          if(window.localStorage.getItem('user') !== undefined) {
            window.localStorage.removeItem('user');
          }
          this.clearToken();
          this.$router.push({ path: '/login' })
        })
        .catch(err => {
          console.log(err)
          this.$Modal.remove()
        })

      // this.$Modal.remove();
    },
    // getSso: function () {
    //   if (this.isTripartite) {
    //     return
    //   }
    //   let that = this
    //   acquire().then(function (res) {
    //     if (!res.data || !res.data.msg) {
    //       return
    //     }
    //     that.$cookies.set('auth_token', res.data.msg.auth_token)
    //     // 获取到 auth_token 去认证换取 access_token
    //     authorization().then(function (res) {
    //       // 签名认证通过
    //       const accessToken = res.data.jwtToken.token
    //       if (accessToken) {
    //         that.$cookies.set('access_token', accessToken)
    //         // 备份cookie 防止标注页面覆盖 用于对比
    //         that.$cookies.set('backups_tonen', accessToken)
    //         // 获取用户权限
    //         that.getAuthInfo()
    //       }
    //     })
    //   })
    // },
    abkLink: function () {
      return abkLink()
    },
    getMessage: function () {
      this.$router.push('/user/message')
    },
    //  打开搜索结果框
    openSearchBox: function () {
      this.showSearchResult = true
    },
    //  关闭搜索结果框
    closeSearchResult () {
      this.isOpen = false
      this.showSearchResult = false
    },
    // 搜索
    async getSearch (type) {
      if (type === 'open') {
        this.isOpen = true
      }
      if (!this.keyWord) {
        return
      }
      if (this.searchPenging) {
        this.$Message.info(window.i18n.t('Layout-TopNav20'))
        return
      }
      this.searchPenging = true
      setTimeout(() => {
        this.showSearchResult = true
      }, 201)

      this.showSearchResult = true
      let result = await getSearch({
        key: this.keyWord
      })
      this.searchPenging = false
      for (let i = 0; i < result.data.length; i++) {
        let reg = new RegExp(this.keyWord, 'g')
        result.data[i].entry = result.data[i].entry.replace(
          reg,
          '<span style="color:#14cb6b">' + this.keyWord + '</span>'
        )
      }
      this.searchResultData = result.data
      this.formatData()
    },
    formatData: function () {
      this.formatResultData.medal = []
      this.formatResultData.task = []
      this.formatResultData.guild = []
      for (var i = 0; i < this.searchResultData.length; i++) {
        if (this.searchResultData[i].entryType === '[任务') {
          this.formatResultData.task.push(this.searchResultData[i])
        } else if (this.searchResultData[i].entryType === '[公会') {
          this.formatResultData.guild.push(this.searchResultData[i])
        } else if (this.searchResultData[i].entryType === '[勋章]') {
          this.formatResultData.medal.push(this.searchResultData[i])
        }
      }
    },
    getSearchDetail: function (item) {
      let keyWord = item.entry.replace(/<\/?.+?>/g, '')
      if (item.entryType === '[公会]') {
        this.$router.push({ path: '/guildList', query: { guildName: keyWord } })
      } else if (item.entryType === '[勋章]') {
        this.$router.push({
          path: '/WorkBench/ExerciseMedal',
          query: { medalName: keyWord }
        })
      } else if (item.entryType === '[任务]') {
        this.$router.push({
          path: '/task/taskDetail',
          query: { id: item.id, openType: item.openType, taskId: item.taskId }
        })
      }
    },
    //  切换语言
    changeLang: function (type) {
      this.localLang = type
      localStorage.setItem('lang', type)
      this.$cookies.set('lang', type)
      this.localLang = type
      // 切换组件语言类型
      // this.$i18n.locale = type

      location.reload()
    },
    // 退出第三方平台
    loginoutLabel: function () {
      tripartiteLogout()
        .then(res => {
          if (!res || !res.data) return
          this.clearToken()
        })
        .catch(err => {
          this.$Message.error(err || window.i18n.t('Layout-TopNav27'))
          this.clearToken()
        })
    },
    // 退出登录
    loginout: function () {
      logout()
        .then(res => {
          if (!res || !res.data) return
          this.clearToken()
        })
        .catch(err => {
          this.$Message.error(err || window.i18n.t('Layout-TopNav27'))
          this.clearToken()
        })
    },
    //跳转到登录记录页
    loginRecord () {
      this.$router.push({ path: '/WorkBench/LoginRecord' })
    },
    clearToken: function () {
      this.$cookies.remove('access_token')
      this.$cookies.remove('backups_tonen')
      this.$cookies.remove('token')
      localStorage.removeItem('hasNoPhoneFlag');
      setLocalStorage('user', null)
      this.$store.dispatch('setUserInfo', null)
      jumpDomain('logout', '/', { path: '/' });
      // this.$router.push({ path: '/' });

      // 解除埋点绑定
      try {
        clearAnalysisWebUser();
      } catch (e) {
        console.log(e)
      }
    },
    // 获取权限
    // getAuthInfo: function () {
    //   getAuthInfo().then(res => {
    //     this.setPermission(res);
    //     this.$refs['notice'].getSignature()
    //      this.$refs['notice'].getNameApproveInfo()
    //     // 获取头部信息
    //     this.getTopInfo()
    //     if (this.$route.path === '/open/default') {
    //       this.$refs['notice'].getSettlement()
    //       this.$refs['notice'].getRealName()
    //     }
    //   })
    // },
    // // 向vuex同步权限信息
    // setPermission: function (data) {
    //   // 默认一个普通用户权限 1
    //   let tempPer = [1]
    //   // 管理员权限 和 协管  2
    //   if (data.data.maxPlatformRoleLevel.name && data.data.maxPlatformRoleLevel.name.indexOf('管') > -1) {
    //     tempPer.push(2)
    //   }
    //   //  公会管理员 和 公会长权限 3
    //   if (data.data.maxGuildRoleLevel > 0) {
    //     tempPer.push(3)
    //   }

    //   // 没有加入公会
    //   if (data.data.maxGuildRoleLevel === -1) {
    //     tempPer.push('noGuild')
    //   }
    //   // 切换公会时同步公会信息到vuex
    //   this.$store.commit('setUserPermission', tempPer)
    // },
    toLink: function (url) {
      window.open(this.abkLink() + url, '_self')
    },
    ruleValidate(str) {
      let count = 0
      let res = true
      let reg1 = /[A-Z]/
      let reg2 = /[a-z]/
      let reg3 = /[0-9]/
      let reg4 = /[^a-zA-Z0-9]/
	  if (str == null || str.length < 8 || str.length > 20) {
          return false;
      }
      if(reg1.test(str)) count ++
      if(reg2.test(str)) count ++
      if(reg3.test(str)) count ++
      if(reg4.test(str)) count ++
      if(count < 3) {
        res = false
      }

      return res
    },
    modeValidate(str) {
      let res = true
      let arr = str.split('')
      let reg = /^[a-zA-Z0-9!@#$%^&*()_+-=]+$/
      let reg2 = /[^a-zA-Z0-9]/
      // if(!reg.test(str)) {
      //   res = false
      // }
      // 递增
      arr.forEach((item, index)=>{
        if(!reg2.test(item)) {
          if(str.charCodeAt(index + 1) == str.charCodeAt(index) + 1 && str.charCodeAt(index + 2) == str.charCodeAt(index) + 2) {
            res = false
            console.log('递增');
          }
        }
      })

      // 递减
      arr.forEach((item, index)=>{
        if(!reg2.test(item)) {
          if(str.charCodeAt(index + 1) == str.charCodeAt(index) - 1 && str.charCodeAt(index + 2) == str.charCodeAt(index) - 2) {
            res = false
            console.log('递减');
          }
        }
      })

      // 连续
      arr.forEach((item, index)=>{
        if(!reg2.test(item)) {
          if(str.charCodeAt(index + 1) == str.charCodeAt(index) && str.charCodeAt(index + 2) == str.charCodeAt(index)) {
            res = false
            console.log('连续');
          }
        }
      })

      return res
    },
    handleMenuClick(val){
      switch(val){
        case '8000':
          // 8000平台
          const url = process.env.NODE_ENV === 'production' ? 
          'https://marking.ahjxabk.com:9455/#/sso-callback' :
          'http://172.30.15.128:8665/#/sso-callback';
          const ticket = this.$cookies.get('access_token') || this.$cookies.get('token');
          const account = this.$store.state.app.userInfo.account;
          window.open(`${url}?ticket=${ticket}&account=${account}`, '_blank');
          break;
      }
    },
     getPermission8000(){
      queryRoleByOpenId().then(res=>{
        if (res.data.length === 0) return;
        // 判断依据用户角色中是否包含8000平台管理员权限
        // 跟产品、后端沟通确认以角色名称来判断
        const hasPer = res.data.some(item => item.roleName === "8000平台管理员");
        if (hasPer) {
          this.secMenuList.push({
            id:'8000',
            title:'8000平台'
          })
        }
      })
    },
  },

  created () {
    // 设置 cookie里的语言
    this.localLang = localStorage.getItem('lang')
    this.$cookies.set('lang', this.localLang)

    this.curPath = this.$route.path
    let accessToken = this.$cookies.get('access_token')
    if (accessToken) {
      this.isLogin = true
    } else {
      this.isLogin = false
    }
    // 获取用户8000平台权限
    this.getPermission8000()
  }
}
</script>
<style>
.ivu-tabs-nav .ivu-tabs-tab-active {
  color: #14cb6b !important;
}
.ivu-tabs-ink-bar {
  background-color: #14cb6b !important;
}
.ivu-tabs-nav .ivu-tabs-tab:hover {
  color: #14cb6b !important;
}
</style>
<style rel="stylesheet/less" lang="less" scoped>
@import '../../assets/theme/themeBlue.less';
/**
  三方
  */
.mark-platform {
  font-size: 16px;
  color: #000;
}
.three-platform-head {
  margin-bottom: 20px;
}
/**
  爱标客
   */
.partner {
  position: fixed;
  left: 5px;
  bottom: 5px;
  height: 66px;
  width: 66px;
  box-sizing: border-box;
  border-radius: 3px;
  text-align: center;
  font-size: 20px;
  line-height: 24px;
  padding: 10px;
  z-index: 999;
  background: linear-gradient(270deg, #2ed580 0%, #24c6a2 100%);
  a {
    color: #fff;
    font-weight: normal;
  }
}
.input {
  width: 200px;
  height: 30px;
  position: relative;
}
.input .searchIcon {
  right: 170px;
  display: inline-block;
  width: 18px;
  height: 19px;
  background: url(../../assets/images/default/search.png) no-repeat center
    center;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.5s ease;
  cursor: pointer;
}
.input input {
  float: left;
  font-size: 14px;
  border-radius: 3px;
  outline: none;
  height: 100%;
  line-height: 100%;
  padding: 0 35px 0 8px;
  border: 0px solid @primary;
  width: 0%;
  transition: all 0.5s ease;
}

.input.open input {
  border: 1px solid @primary;

  width: 100%;

  // color: #AFAFAF;

  &::placeholder {
    color: #afafaf;
  }
}

.input.radius input {
  border-radius: 15px;
}

.input input:focus {
  border: 1px solid @primary-hover;
}

// .input .icon{
//    position: absolute;
//    right: 5px;
//    top: 7px;
//    cursor: pointer;
// }
.input.open .searchIcon {
  right: 15px;
}

.portalLogin {
  line-height: 21px;

  .btn {
    float: right;
    height: 60px;
    padding: 12px 0;
    text-align: right;

    span {
      display: inline-block;
      font-size: 14px;
      // width: 96px;
      background: rgba(20, 203, 107, 1);
      border-radius: 16px;
      padding: 7px 18px;
      text-align: center;
      color: #fff;
    }

    .loginP {
      background: transparent;
      border-radius: 16px;
      color: #14cb6b;
    }

    .register {
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .name {
    float: right;
    font-weight: normal;
    font-size: 12px;
    margin-top: 18px;
  }
}

.more {
  margin-right: 10px;
  u {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    /* Internet Explorer */
    -moz-transform: rotate(0deg);
    /* Firefox */
    -webkit-transform: rotate(0deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(0deg);
  }
}
.mobile:hover {
  u {
    transform: rotate(90deg);
    -ms-transform: rotate(90deg);
    /* Internet Explorer */
    -moz-transform: rotate(90deg);
    /* Firefox */
    -webkit-transform: rotate(90deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(90deg);
    /* Opera */
  }

  .img {
    display: block;
  }
}

u {
  animation: all 0.15s;
  -moz-transition: all 0.15s;
  /* Firefox 4 */
  -webkit-transition: all 0.15s;
  /* Safari 和 Chrome */
  -o-transition: all 0.15s;
  text-decoration: none;
  color: #5e6a68;
  display: inline-block;
  transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  /* Internet Explorer */
  -moz-transform: rotate(-90deg);
  /* Firefox */
  -webkit-transform: rotate(-90deg);
  /* Safari 和 Chrome */
  -o-transform: rotate(-90deg);
  /* Opera */
  display: inline-block;
  width: 10px;
  height: 10px;
  background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTg1Mzc3Mzg4MDkxIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjMzNzEiIHdpZHRoPSIxMCIgaGVpZ2h0PSIxMCIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTIzMy42IDEwMjRjNi40IDAgMTIuOC0zLjIgMTkuMi02LjRsNjQwLTQ4MGM5LjYtNi40IDEyLjgtMTYgMTIuOC0yNS42cy0zLjItMTkuMi0xMi44LTI1LjZMMjUyLjggNi40QzI0MC0zLjIgMjE3LjYgMCAyMDggMTZjLTkuNiAxMi44LTYuNCAzMiA2LjQgNDQuOEw4MTkuMiA1MTIgMjE0LjQgOTY2LjRjLTEyLjggOS42LTE2IDMyLTYuNCA0NC44IDYuNCA5LjYgMTYgMTIuOCAyNS42IDEyLjh6IiBmaWxsPSIjYmZiZmJmIiBwLWlkPSIzMzcyIj48L3BhdGg+PC9zdmc+)
    no-repeat center center;
}
.page-header .manage {
  position: absolute;
  float: right;
  top: 0px;
  right: 100px;
  a {
    font-size: 14px;
  }
}
.page-header .manage1 {
  right: 200px;
  .top-nav {
    margin-right: 10px;
  }
}
.page-header .manage2 {
  right: 300px;
}
.page-header .manage3 {
  right: -20px;
}

.mobile {
  position: relative;
  .box {
    display: none;
    position: absolute;
    top: 45px;
    left: 50%;
    transform: translateX(-50%);
    z-index: 9999;
    width: 120px;
    // height: 80px;
    background: #fff;
    box-shadow: 0px 5px 19px 2px rgba(4, 0, 0, 0.07);
    border-radius: 4px;
    padding: 10px 18px;

    .type {
      font-size: 14px;
      font-weight: 500;
      line-height: 30px;
      height: 30px;
      cursor: pointer;
      position: relative;
      .comment {
        text-align: center;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width:84px;
      }

      .img {
        display: none;
        width: 139px;
        // height:169px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 13px 6px 15px 1px rgba(4, 0, 0, 0.07);
        border-radius: 2px;
        position: absolute;
        left: calc(100% + 18px);
        top: 0;
        padding: 10px;
        padding-top: 15px;
        color: #45cf7b;
        line-height: 18px;

        img {
          margin-bottom: 5px;
          width: 108px;
          height: 108px;
        }
      }

      i {
        display: inline-block;
        width: 15px;
        height: 15px;
        position: absolute;
      }

      .topLeft {
        border-left: 2px solid #45cf7b;
        border-top: 2px solid #45cf7b;
        top: 10px;
        left: 10px;
      }

      .topRight {
        border-right: 2px solid #45cf7b;
        border-top: 2px solid #45cf7b;
        top: 10px;
        left: 112px;
      }

      .bottomLeft {
        border-left: 2px solid #45cf7b;
        border-bottom: 2px solid #45cf7b;
        top: 112px;
        left: 10px;
      }

      .bottomRight {
        border-right: 2px solid #45cf7b;
        border-bottom: 2px solid #45cf7b;
        top: 112px;
        left: 112px;
      }
    }

    .type:hover {
      color: #45cf7b;

      u {
        color: #45cf7b;
        transform: rotate(0deg);
        -ms-transform: rotate(0deg);
        /* Internet Explorer */
        -moz-transform: rotate(0deg);
        /* Firefox */
        -webkit-transform: rotate(0deg);
        /* Safari 和 Chrome */
        -o-transform: rotate(0deg);
        /* Opera */
      }

      .img {
        display: block;
      }
    }
  }
}

.mobile:hover {
  .box {
    display: block;
  }
}

.head {
  background: #fff;
}

.page-header {
  background: #fff;
  height: 60px;
  line-height: 60px;
  width: 100%;
  font-size: 16px;
  font-weight: bold;
  position: relative;
  // width: 1200px;
  // margin: 0 auto;
  .logo {
    display: inline-block;
    width: 115px;
    height: 45px;
    position: absolute;
    left: 18px;
    top: 7px;
    background: url(../../assets/images/default/new_logo.png) no-repeat center
      center;
  }
  .logo-subtitle {
    display: inline-block;
    position: absolute;
    left: 140px;
    top: -8px;
    font-size: 20px;
    font-weight: normal;
  }
  .nav {
    // width: 500px; //有导航暂时不用
    width: 800px;
    margin: 0 auto;
    // overflow: hidden;
    height: 60px;
    position: relative;
    left: -80px;
  }

  .item {
    // padding: 0 26px;
    padding: 0 21px;
    text-align: center;
    float: left;
    font-size: 16px;

    a {
      color: @title-text;
    }

    .active {
      color: #4ddb90;
    }
  }

  .search {
    position: absolute;
    right: 10%;
    top: 15px;

    .searchResult::before {
      content: '';
      position: absolute;
      display: inline-block;
      width: 12px;
      height: 12px;
      background: #fff;
      border-left: 1px solid rgba(228, 231, 237, 1);
      border-top: 1px solid rgba(228, 231, 237, 1);
      top: -6px;
      left: calc(20% - 5px);
      transform: rotate(45deg);
    }

    .searchResult {
      position: relative;
      top: 38px;
      max-height: 250px;
      width: 340px;
      background: #fff;
      box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.06);
      border: 1px solid rgba(228, 231, 237, 1);
      border-radius: 3px;
      position: absolute;
      z-index: 9999;
      padding: 20px;
      padding-top: 15px;

      .box {
        max-height: 180px;
        // overflow: hidden;
        .tab {
          overflow-y: auto;
          height: 130px;
          overflow-x: hidden;
        }
      }

      /* 设置滚动条的样式 */
      .tab::-webkit-scrollbar {
        width: 5px;
        background-color: #ddd;
      }

      /* 滚动槽 */
      .tab::-webkit-scrollbar-track {
        border-radius: 15px;
      }

      /* 滚动条滑块 */
      .tab::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #999;
      }

      p {
        color: #a1a1a1;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        cursor: pointer;

        span {
          color: #333;
        }
      }
    }
  }

  .notice {
    width: 18px;
    height: 60px;
    position: absolute;
    right: 64px;
    top: 0;
    line-height: 24px;
    color: @primary-hover;
    font-weight: 900;
    background: url(../../assets/images/default/notice_t.png) no-repeat center
      center;
    cursor: pointer;

    span {
      display: inline-block;
      background: red;
      height: 16px;
      min-width: 16px;
      text-align: center;
      line-height: 16px;
      font-size: 10px;
      position: absolute;
      left: 70%;
      top: 12px;
      border-radius: 8px;
      padding: 0 2px;
      color: #fff;
    }
  }

  .login {
    position: absolute;
    right: 75px;
    top: 0;
    font-size: 12px;
    font-weight: normal;
    // height: 14px;

    div {
      // width: 115px;
      // overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    a {
      color: rgba(20, 203, 107, 1);
      font-size: 14px;
      font-weight: 900;
    }
    .name {
      height: 20px;
      line-height: 20px;
      margin-top: 19px;
      a {
        font-size: 12px;
        display: inline-block;
        height: 20px;
        line-height: 20px;
      }
    }
  }

  .lang {
    position: absolute;
    right: 10px;
    top: 7px;
  }

  .lang a {
    display: inline-block;
    width: 27px;
    height: 22px;

    span {
      display: inline-block;
      width: 23px;
      height: 17px;
      line-height: 23px;
    }

    .box {
      border: 1px solid #14cb6b;
      border-radius: 4px;
      position: relative;
      top: -4px;
    }

    .text {
      border: 1px solid #14cb6b;
      border-radius: 4px;
      background: #14cb6b;
      color: #fff;
      position: relative;
      top: -2px;
      right: 4px;
      line-height: 16px;
      font-size: 12px;
      text-align: center;
      font-weight: normal;
    }
  }

  .lang .langEn {
    // background: url(../../assets/images/default/lang.png) no-repeat center center;
  }

  .lang .langCn {
    // background: url(../../assets/images/default/default_step1.png);
  }
}
.tipsClass {
  width: 300px;
  word-break: break-all;
  word-wrap: break-word;
}
</style>
